import Modal from "./modal.js";
import { createElement } from "./dom_utils.js";

class ImagePreviewModal {
  constructor() {
    this.modal = new Modal();
  }

  open(imageUrl) {
    const container = createElement("div", {
      style: `
        width: 90vw;
        max-width: 800px;
        height: auto;
        max-height: 80vh;
        position: relative;
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
      `,
    });

    const img = createElement("img", {
      src: imageUrl,
      alt: "Preview",
      style:
        "width: 100%; height: 100%; max-height: 70vh; object-fit: contain; border-radius: 8px;",
    });

    container.appendChild(img);
    this.modal.open(container);
  }

  close() {
    this.modal.close();
  }
}

export default ImagePreviewModal;
